import script from "./ui-click-outside.vue?vue&type=script&lang=js"
export * from "./ui-click-outside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__